import { render, staticRenderFns } from "./AdminNavigationHelper.vue?vue&type=template&id=dd513d4e&"
import script from "./AdminNavigationHelper.vue?vue&type=script&lang=js&"
export * from "./AdminNavigationHelper.vue?vue&type=script&lang=js&"
import style0 from "./AdminNavigationHelper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBadge,VIcon,VImg,VList,VListItem,VListItemContent,VListItemTitle,VNavigationDrawer})
